/**
 * Business-profile feature flag keys, as stored in the profile's
 * Settings table (key/value rows). Add new server flags here only.
 */
export const BP_FEATURE_FLAGS = {
  STUNNR_AI: 'BusinessProfile.IsStunnrAIEnabled'
} as const;

/** Key prefix that selects all business-profile settings in one fetch. */
export const BP_SETTINGS_KEY_PREFIX = 'BusinessProfile.';

